/**
 * Contact form — stores messages in Supabase for webmaster review.
 */
(function () {
  'use strict';

  function setFieldError(field, message) {
    const wrap = field.closest('.form-field');
    if (!wrap) return;
    let err = wrap.querySelector('.field-error');
    if (message) {
      field.setAttribute('aria-invalid', 'true');
      if (!err) {
        err = document.createElement('span');
        err.className = 'field-error';
        err.id = field.id + '-error';
        wrap.appendChild(err);
      }
      err.textContent = message;
      field.setAttribute('aria-describedby', err.id);
    } else {
      field.removeAttribute('aria-invalid');
      field.removeAttribute('aria-describedby');
      err?.remove();
    }
  }

  function validateForm(form) {
    let valid = true;
    const name = form.name;
    const email = form.email;
    const message = form.message;

    setFieldError(name, '');
    setFieldError(email, '');
    setFieldError(message, '');

    if (!name.value.trim()) {
      setFieldError(name, 'Please enter your name.');
      valid = false;
    }
    if (!email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      setFieldError(email, 'Please enter a valid email address.');
      valid = false;
    }
    if (!message.value.trim()) {
      setFieldError(message, 'Please enter a message.');
      valid = false;
    } else if (message.value.trim().length < 10) {
      setFieldError(message, 'Please write at least a few words.');
      valid = false;
    }
    return valid;
  }

  async function init() {
    await Troop936Content.applySiteSettings();

    const form = document.getElementById('contact-form');
    const status = document.getElementById('contact-status');
    const submitBtn = document.getElementById('contact-submit');
    if (!form) return;

    form.querySelectorAll('input, textarea').forEach((field) => {
      field.addEventListener('input', () => setFieldError(field, ''));
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!validateForm(form)) {
        status.textContent = 'Please fix the errors above.';
        status.className = 'form-status error';
        return;
      }

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      status.textContent = '';
      status.className = 'form-status loading';
      status.textContent = 'Sending your message…';

      try {
        await Troop936Content.submitContact(form);
        window.location.href = 'thank-you.html?type=contact';
      } catch (err) {
        status.textContent = err.message || 'Could not send message. Please email the scoutmaster directly.';
        status.className = 'form-status error';
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

export {};
